<template>
  <div
    class="delegation_groupItem"
    :id="`matchList_${data.icon}`"
    :style="{ paddingBottom: `${pbPx}px` }"
  >
    <div class="delegation_label">
      <span class="label_textArea">
        <!-- <span class="labelIcon">
          <img :src="data.icon" />
        </span> -->
        <span
          :class="[data.label && data.label.length === 2 ? 'letterSpa' : '']"
          v-text="_valPerFormatHandler(data.label)"
        ></span>
      </span>
    </div>
    <div class="delegation_list">
      <span
        class="delegation_item"
        @click="goDetail(item)"
        v-for="item in data.list"
        :key="item.organisationCode"
      >
        <div class="delegation_itemMain">
          <span class="delegation_item_row1">
            <span class="logo" :class="item.organisationLogo">
              <img v-if="item.organisationLogo" :src="item.organisationLogo" />
            </span>
            <span
              class="logoCode"
              v-text="_valPerFormatHandler(item.organisationCode)"
            ></span>
          </span>
          <span
            class="delegation_item_row2"
            v-text="_valPerFormatHandler(item.organisationName)"
          ></span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'delegation_groupItem',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          label: '艺术体操',
          icon: 'GRY',
          list: [
            {
              seasonCode: 'WUSG31',
              organisationCode: 'ALB',
              organisationName: '阿尔巴尼亚',
              orgNameInitial: 'A',
              orgNameCNCode: 'a er ba ni ya',
              organisationLogo: '',
            },
            {
              seasonCode: 'WUSG31',
              organisationCode: 'AFG',
              organisationName: '阿富汗',
              orgNameInitial: 'A',
              orgNameCNCode: 'a fu han',
              organisationLogo: '',
            },
          ],
        }
      },
    },
    pbPx: {
      type: Number,
      default: () => {
        return 40
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    goDetail(item) {
      this.pageJump(
        this.$router,
        `CSMeetDelegationDetailIndex_${this.currCid}`,
        {
          delegationId: item.organisationCode,
        },
        item
      )
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .delegation_groupItem {
    width: 100%;
    height: auto;
    .delegation_label {
      position: relative;
      width: 100%;
      height: 3.472vw;
      background-image: var(--mixtmt_scheduleMatchList_dateBg);
      background-size: 100% auto;
      background-position: left top;
      background-repeat: no-repeat;

      .label_textArea {
        position: absolute;
        left: 0;
        top: 0.347vw;
        z-index: 2;
        width: 21.55%;
        padding-top: 0.6%;
        font-size: 1.38vw;
        color: var(--mixtmt_whiteColor);
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .labelIcon {
          width: 1.8vw;
          height: 1.8vw;
          overflow: hidden;
          margin-right: 0.694vw;
        }
        & .letterSpa {
          letter-spacing: 0.4vw;
        }
      }
    }
    .delegation_list {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .delegation_item {
        width: 20%;
        padding: 0.694vw 0;
        height: auto;
        .delegation_itemMain {
          width: 100%;
          height: auto;
          padding: 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          border-radius: 0.278vw;
          border: 1px solid var(--mixtmt_whiteColor);
          -webkit-transform: perspective(1px) translateZ(0);
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          position: relative;
          -webkit-transition-property: color;
          transition-property: color;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          &:before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: var(--mixtmt_mainColor4);
            /* border: 1px solid var(--mixtmt_mainColor); */
            -webkit-transform: scaleX(0);
            transform: scaleX(0);
            -webkit-transform-origin: 0 50%;
            transform-origin: 0 50%;
            -webkit-transition-property: transform;
            transition-property: transform;
            -webkit-transition-duration: 0.3s;
            transition-duration: 0.3s;
            -webkit-transition-timing-function: ease-out;
            transition-timing-function: ease-out;
          }
          .delegation_item_row1 {
            width: 100%;
            height: 2.778vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            .logo {
              position: relative;
              width: 4.16vw;
              height: 2.778vw;
              overflow: hidden;
              background-color: var(--mixtmt_greyColor0);
              &.isLogo {
                background-color: transparent;
              }
              &::before {
                content: '\20';
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                width: 100%;
                height: 100%;
                border: 1px solid var(--mixtmt_greyColor5);
              }
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            .logoCode {
              width: 4.16vw;
              height: 2.778vw;
              overflow: hidden;
              line-height: 2.778vw;
              font-size: 1.38vw;
              text-align: center;
              background-color: var(--mixtmt_greyColor7);
              color: var(--mixtmt_greyColor4);
            }
          }
          .delegation_item_row2 {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-top: 1.11vw;
            line-height: 1.38vw;
            font-size: 1.25vw;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
    }
  }
}

.mixtmt_pc {
  .delegation_groupItem {
    .delegation_list {
      .delegation_item {
        &:hover {
          cursor: pointer;
          .delegation_itemMain {
            /* background-color: var(--mixtmt_mainColor4); */
            border: 1px solid var(--mixtmt_mainColor);
            &::before {
              -webkit-transform: scaleX(1);
              transform: scaleX(1);
            }
          }
        }
      }
    }
  }
}
</style>
